import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Urls } from '../../../utils/catalogue/urls';
import { ApiService } from '../../../shared/catalogue/services/api.service';
import { CommonDataService } from '../../../shared/catalogue/services/common-data.service';
import { DATA_PER_PAGE, CANCEL, Data_deleted } from './../../../app.constant';

@Component({
  selector: 'app-user-data',
  templateUrl: './user-data.component.html',
  styleUrls: ['./user-data.component.scss']
})
export class UserDataComponent implements OnInit {
  activeTab = 'let-us-help';
  categoryList = [
    {
      val: 'Let us help you',
      section: 'let-us-help'
    },
    {
     val: 'Call Back',
     section: 'call-back'
    },
    {
      val: 'Write to Us',
      section: 'write-us'
     },
     {
      val: 'Careers',
      section: 'careers'
     }
  ];
helpData = [];
callData = [];
writeData = [];
careerData = [];

pageSize: number = DATA_PER_PAGE;

  constructor(public apiService: ApiService,
              public commonDataService: CommonDataService,
              private toastr: ToastrService, ) { }

  ngOnInit() {
    this.getHelpData();
  }

  getHelpData = () => {
    this.apiService.getData(Urls.getCustomerContactDetails).subscribe((response: any) => {
      this.helpData = response.data.customerList;
      this.getCallBackData();
    });
  }

  getCallBackData = () => {
    this.apiService.postData(Urls.getinfo, {type: 1}).subscribe((response: any) => {
      this.callData = response.data.returnList;
      this.getWriteToData();
    });
  }

  getWriteToData = () => {
    this.apiService.postData(Urls.getinfo, {type: 0}).subscribe((response: any) => {
      this.writeData = response.data.returnList;
      this.getCareerData();
    });
  }

  getCareerData = () => {
    this.apiService.postData(Urls.getinfo, {type: 2}).subscribe((response: any) => {
      this.careerData = response.data.returnList;
    });
  }


  deleteData = (id, type) => {
    this.commonDataService.confirm('Are you sure want to delete?', 'md')
    .then((confirmed) => {
     if (confirmed) {
      if (type === 4) {
        this.apiService.postData(Urls.deleteCustomerContact, {id}).subscribe((response: any) => {
          this.toastr.success(Data_deleted);
          this.getHelpData();
        });
      } else {
        this.apiService.postData(Urls.deleteinfo, {id, type}).subscribe((response: any) => {
          this.toastr.success(Data_deleted);
          this.getHelpData();
        });
      }

     }
    })
    .catch(() => {
      this.toastr.error(CANCEL);
    });


  }

  viewFile = (path) => {
    window.open(path, '_blank');
  }

}
